import Joi from 'joi'
import errorsResolver from '../schemeUtils'
import { cityTypes, streetTypes } from '../../helpers/data-constants'

const ORGANIZATION_LENGTH = 200
const POSITION_LENGTH = 100
const PHONE_LENGTH = 20
const CITY_LENGTH = 100
const REGION_LENGTH = 100

const STREET_LENGTH = 100
const HOUSE_LENGTH = 10
const BUILDING_LENGTH = 10
const APARTMENT_LENGTH = 10

const clientEmployerScheme = Joi.object({
    index: Joi.any(),
    organization: Joi.string()
        .trim()
        .required()
        .max(ORGANIZATION_LENGTH)
        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\-()/., ]*$`))
        .error(errorsResolver({
            required: `Наименование организации обязательное поле`,
            pattern: `Наименование организации содержит некорректные символы`,
            max: `Наименование организации должно быть не более ${ORGANIZATION_LENGTH} символов`
        })),
    position: Joi.string()
        .trim()
        .required()
        .max(POSITION_LENGTH)
        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ\\- ]*$`))
        .error(errorsResolver({
            required: `Должность обязательное поле`,
            pattern: `Должность содержит некорректные символы`,
            max: `Должность должна быть не более ${POSITION_LENGTH} символов`
        })),
    phone: Joi.string()
        .trim()
        .allow('')
        .max(PHONE_LENGTH)
        .pattern(new RegExp(`^[0-9-+ ]*$`))
        .error(errorsResolver({
            max: `Номер телефона должен быть длинной ${PHONE_LENGTH} символов`,
            pattern: `Номер телефона содержит некорректные символы`
        })),
    accountingPhone: Joi.string()
        .trim()
        .allow('')
        .max(PHONE_LENGTH)
        .pattern(new RegExp(`^[0-9-+ ]*$`))
        .error(errorsResolver({
            max: `Номер телефона бухгалтерии должен быть длинной ${PHONE_LENGTH} символов`,
            pattern: `Номер телефона бухгалтерии содержит некорректные символы`
        })),
    startDate: Joi.date()
        .required()
        .iso()
        .error(errorsResolver({
            dateFormat: `Некорректная дата начала`
        })),
    endDate: Joi.date()
        .iso()
        .allow('')
        .greater(Joi.ref("startDate"))
        .error(errorsResolver({
            dateFormat: `Некорректная дата окончания`,
            dateGreater: `Срок окончания должен быть больше даты начала`
        })),
    country: Joi.alternatives().conditional(Joi.object(), {
        then: Joi.object({
            label: Joi.string()
                .required('')
                .error(errorsResolver({
                    required: `Страна обязательное поле`
                })),
            value: Joi.number()
                .error(errorsResolver({
                    number: `Должно быть число`
                }))
        })
            .invalid(null)
            .required()
            .error(errorsResolver({
                invalid: `Страна обязательное поле`,
                required: `Страна обязательное поле`
            })),
        otherwise: Joi.string()
            .required()
            .invalid(null)
            .error(errorsResolver({
                invalid: `Страна обязательное поле`,
                required: `Страна обязательное поле`
            }))
    }),
    region: Joi.string()
        .trim()
        .allow('')
        .max(REGION_LENGTH)
        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ\\- ]*$`))
        .error(errorsResolver({
            pattern: `Область содержит некорректные символы`,
            max: `Область должна быть не более ${REGION_LENGTH} символов`
        })),
    cityType: Joi.string()
        .required()
        .valid(...cityTypes)
        .error(errorsResolver({
            required: `Тип населенного пункта обязательное поле`,
            values: `Тип населенного пункта обязательное поле`
        })),
    streetType: Joi.string()
        .required()
        .valid(...streetTypes)
        .error(errorsResolver({
            required: `Тип адреса обязательное поле`,
            values: `Тип адреса обязательное поле`
        })),
    city: Joi.string()
        .trim()
        .required()
        .max(CITY_LENGTH)
        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ ]*$`))
        .error(errorsResolver({
            required: `Населенный пункт обязательное поле`,
            pattern: `Населенный пункт содержит некорректные символы`,
            max: `Населенный пункт должен быть не более ${CITY_LENGTH} символов`
        })),
    house: Joi.string()
        .required()
        .max(HOUSE_LENGTH)
        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9-:/]*$`))
        .error(errorsResolver({
            required: `Дом обязательное поле`,
            pattern: `Дом содержит некорректные символы`,
            max: `Дом должен быть не более ${HOUSE_LENGTH} символов`
        })),
    street: Joi.string()
        .trim()
        .required()
        .max(STREET_LENGTH)
        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\-()/., ]*$`))
        .error(errorsResolver({
            required: `Улица обязательное поле`,
            pattern: `Улица содержит некорректные символы`,
            max: `Улица должна быть не более ${STREET_LENGTH} символов`
        })),
    building: Joi.string()
        .allow('')
        .max(BUILDING_LENGTH)
        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9-:/]*$`))
        .error(errorsResolver({
            pattern: `Корпус содержит некорректные символы`,
            max: `Корпус должен быть не более ${BUILDING_LENGTH} символов`
        })),
    apartment: Joi.string()
        .allow('')
        .max(APARTMENT_LENGTH)
        .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9-:/]*$`))
        .error(errorsResolver({
            pattern: `Помещение содержит некорректные символы`,
            max: `Помещение должно быть не более ${APARTMENT_LENGTH} символов`
        }))
})

export default clientEmployerScheme
